"use strict";

exports.__esModule = true;
exports.isCssVariable = exports.applyThemeVariables = void 0;
var _wixSiteThemeVariables = require("@wix/wix-site-theme-variables");
const CSS_VARIABLE_REGEX = /var\((?:[^()]+|\((?:[^()]+|\([^()]*\))*\))*\)/g;
const isCssVariable = value => CSS_VARIABLE_REGEX.test(value);
exports.isCssVariable = isCssVariable;
const applyThemeVariables = (cssValue, themeVariables) => {
  const extractVariableName = value => {
    var _value$match;
    return (_value$match = value.match(/var\(--\s*([^,\s)]+)/)) == null ? void 0 : _value$match[1];
  };
  const getThemeToken = variableName => {
    return themeVariables[variableName] && variableName in _wixSiteThemeVariables.WixThemeVariableNames ? themeVariables[variableName] : undefined;
  };
  return cssValue.replace(CSS_VARIABLE_REGEX, match => {
    const variableName = extractVariableName(match);
    if (typeof variableName !== 'undefined') {
      const themeToken = getThemeToken(variableName);
      return themeToken ? themeToken : match;
    }
    return match;
  });
};
exports.applyThemeVariables = applyThemeVariables;
//# sourceMappingURL=apply-theme-variables.js.map